import React from 'react'
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconCloseBlack } from '../assets/icons/ic-close-black.svg';
import packageJson from '../../package.json';

const DeepSightInfo = ({ isOpen, title, message, onOk, onCancel }) => {
    const { t } = useTranslation()

    return (
        isOpen &&
        <div className="absolute w-full h-full content-center whitespace-pre-line" style={{ top: 0, left: 0, background: 'rgba(0,0,0,0.3)', zIndex: 10000 }}>
            <div className="mx-auto w-[884px] h-[660px] bg-[#DEDEDE] text-center flex flex-col rounded-[8px]">
                <div className="flex h-[38px] bg-[#CECECE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">
                    <div className="">{title || 'MODAL'}</div>
                    <IconCloseBlack className="ml-auto cursor-pointer" onClick={() => { onCancel() }}/>
                </div>        
                <div className="flex-1 flex items-center justify-center bg-[#DEDEDE] px-[20px]">{message || 'MODAL Message'}</div>                
                <div className="flex items-center justify-between bg-[#DEDEDE] px-[20px] py-[12px] rounded-bl-[8px] rounded-br-[8px]">           
                    <div>
                        <span>version : {packageJson.version}</span>
                    </div>             
                    <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] cursor-pointer text-[#FFF] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { onOk() }} >{t('deepSightInfo.ok')}</div>
                </div>             
            </div>
        </div>
    )
}

export default DeepSightInfo